export default __webpack_public_path__ + "static/media/cholet2.dbd0b018.jpg";